import { render } from "./GridTabOportunitati.vue?vue&type=template&id=1a6fa720&scoped=true&ts=true"
import script from "./GridTabOportunitati.vue?vue&type=script&lang=ts"
export * from "./GridTabOportunitati.vue?vue&type=script&lang=ts"

import "./GridTabOportunitati.vue?vue&type=style&index=0&id=1a6fa720&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6fa720"]])

export default __exports__